<template>
   <div id="basica_servicio_externo">
      <div v-if="loading" id="loading" class="loading_full">Loading&#8230;</div>
      <div>
         <div
            v-if="servicio_externo.estado_servicio == 0"
            class="text-warning fw-bold mt-2 mb-4"
         >
            <i class="fa fa-info-circle"></i> Este servicio se encuentra
            inactivo.
         </div>
         <h4 class="mb-4 fw-bold text-info">Cotizador</h4>
         <div v-if="permiso">
            <div class="text-end mb-3">
               <button
                  data-bs-toggle="modal"
                  data-bs-target="#nueva_estrategia"
                  class="btn btn-success btn-sm rounded-pill"
               >
                  <i class="fa fa-plus-circle"></i> Nueva estrategia
               </button>
            </div>
            <div v-if="estrategias.length != 0" class="card card-body shadow">
               <div class="table-responsive">
                  <table class="table table-hover table-condensed my_table_2">
                     <thead>
                        <tr>
                           <th>Nombre</th>
                           <th class="text-end">Valor</th>
                           <th class="text-end">Opciones</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr
                           v-for="(estrategia, index_estrategia) in estrategias"
                           :key="index_estrategia"
                        >
                           <td class="fw-bolder text-primary">
                              {{ estrategia.estrategia }}
                           </td>
                           <td class="text-end fw-bolder text-success">
                              {{ estrategia.valor | currency }}
                           </td>
                           <td class="text-end">
                              <button
                                 @click="editarEstrategia(estrategia)"
                                 data-bs-toggle="modal"
                                 data-bs-target="#editar_estrategia"
                                 class="btn btn-info btn-sm btn-rounded me-1"
                              >
                                 <i class="fa fa-edit"></i>
                              </button>
                              <button
                                 @click="
                                    confirmarEliminarEstrategia(estrategia)
                                 "
                                 class="btn btn-danger btn-sm btn-rounded"
                              >
                                 <i class="fa fa-trash"></i>
                              </button>
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
            <div v-else class="alert alert-light mb-0">
               No hay estrategias registradas.
            </div>
         </div>
      </div>
      <div
         class="modal fade"
         id="nueva_estrategia"
         tabindex="-1"
         role="dialog"
      >
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Nueva estrategia</h5>
                  <button
                     id="close_modal_nueva_estrategia"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="mb-3">
                     <label class="form-label fw-bold"
                        >Nombre de la estrategia</label
                     >
                     <input
                        v-model="nueva_estrategia.estrategia"
                        type="text"
                        class="form-control"
                     />
                  </div>
                  <div class="mb-3">
                     <label class="form-label fw-bold">Valor</label>
                     <money
                        v-model="nueva_estrategia.valor"
                        class="form-control text-end"
                        v-bind="money"
                        required
                     ></money>
                  </div>
                  <div class="text-end">
                     <button
                        type="button"
                        class="btn btn-secondary btn-rounded btn-sm"
                        data-bs-dismiss="modal"
                     >
                        Cancelar
                     </button>
                     <button
                        @click="setEstrategia"
                        type="button"
                        class="btn btn-success btn-rounded btn-sm ms-2"
                     >
                        Guardar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div
         class="modal fade"
         id="editar_estrategia"
         tabindex="-1"
         role="dialog"
      >
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Editar estrategia</h5>
                  <button
                     id="close_modal_pago"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="estrategia != null" class="modal-body">
                  <div class="mb-3">
                     <label class="form-label fw-bold"
                        >Nombre de la estrategia</label
                     >
                     <input
                        v-model="estrategia.estrategia"
                        type="text"
                        class="form-control"
                     />
                  </div>
                  <div class="mb-3">
                     <label class="form-label fw-bold">Valor</label>
                     <money
                        v-model="estrategia.valor"
                        class="form-control text-end"
                        v-bind="money"
                        required
                     ></money>
                  </div>
                  <div class="text-end">
                     <button
                        @click="estrategia = null"
                        type="button"
                        class="btn btn-secondary btn-rounded btn-sm"
                        data-bs-dismiss="modal"
                     >
                        Cancelar
                     </button>
                     <button
                        @click="updateEstrategia()"
                        type="button"
                        class="btn btn-success btn-rounded btn-sm ms-2"
                     >
                        Guardar cambios
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import axios from "axios";
export default {
   name: "Cotizador_servicio_externo",
   metaInfo: {
      title: "Cotizador de servicio externo - Backoffice",
   },
   data() {
      return {
         loading: true,
         id_servicio: null,
         estrategias: [],
         estrategia: null,
         nueva_estrategia: {
            estrategia: null,
            valor: 0,
         },
         money: {
            decimal: ",",
            thousands: ".",
            prefix: "$ ",
            suffix: "",
            precision: 0,
            masked: false,
         },
      };
   },
   props: {
      session: Object,
      servicio_externo: Object,
      permiso: Boolean,
   },
   created: function () {
      this.id_servicio = this.$route.params.id_servicio;
      this.getEstrategias();
   },
   methods: {
      getEstrategias: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
         };
         let config = {
            headers: headers,
         };
         axios
            .get(
               vm.$base_url + "servicios/estrategiasServicio/" + vm.id_servicio,
               config,
               {
                  headers: headers,
               },
            )
            .then((response) => {
               if (response.data.status) {
                  vm.estrategias = response.data.data.estrategias;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
               vm.loading = false;
            });
      },
      editarEstrategia: function (estrategia) {
         this.estrategia = estrategia;
      },
      setEstrategia: function () {
         const vm = this;

         if (
            vm.nueva_estrategia.estrategia == null ||
            vm.nueva_estrategia.estrategia.trim().length == 0
         ) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Advertencia",
               text: "El nombre de la estrategia no puede estar vacío.",
            });
            return false;
         }

         if (Number(vm.nueva_estrategia.valor) <= 0) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Advertencia",
               text: "El valor de la estrategia debe ser mayor a cero.",
            });
            return false;
         }

         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_servicio: this.id_servicio,
            estrategia: vm.nueva_estrategia,
         };

         axios
            .post(this.$base_url + "servicios/setEstrategia", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Advertencia",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Éxito",
                     text: response.data.message,
                  });
                  vm.nueva_estrategia = {
                     estrategia: null,
                     valor: 0,
                  };
                  document
                     .getElementById("close_modal_nueva_estrategia")
                     .click();
                  vm.getEstrategias();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      updateEstrategia: function () {
         const vm = this;
         var valida = true;
         if (this.estrategia.estrategia.length == 0) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Advertencia",
               text: "El nombre de la estrategia no puede estar vacío.",
            });
            valida = false;
         }
         if (this.estrategia.valor.length == 0) {
            vm.$notify({
               group: "foo",
               type: "error",
               title: "Advertencia",
               text: "El valor de la estrategia no puede estar vacío.",
            });
            valida = false;
         }
         if (!valida) {
            return false;
         }

         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            id_servicio: this.id_servicio,
            estrategia: this.estrategia,
         };
         axios
            .post(this.$base_url + "servicios/updateEstrategia", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Advertencia",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Éxito",
                     text: response.data.message,
                  });
               }
               vm.getEstrategias();
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
      confirmarEliminarEstrategia: function (estrategia) {
         this.$swal
            .fire({
               title: "",
               html:
                  "¿Está seguro que desea eliminar la estrategia <strong>" +
                  estrategia.estrategia +
                  "</strong>?",
               icon: "question",
               showCancelButton: true,
               buttonsStyling: false,
               confirmButtonText: "Sí",
               cancelButtonText: "No",
               customClass: {
                  confirmButton: "btn btn-success rounded-pill me-2",
                  cancelButton: "btn btn-light rounded-pill",
               },
            })
            .then((result) => {
               if (result.isConfirmed) {
                  this.eliminarEstrategia(estrategia);
               }
            });
      },
      eliminarEstrategia: function (estrategia) {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            estrategia_servicio_id: estrategia.estrategia_servicio_id,
         };
         axios
            .post(this.$base_url + "servicios/deleteEstrategia", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Advertencia",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Éxito",
                     text: response.data.message,
                  });
               }
               vm.getEstrategias();
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
   },
   mounted: function () {
      this.loading = false;
   },
};
</script>
